import angular from 'angular';

angular.module('app.core').factory('ChangeIdFormInfo', ChangeIdFormInfo);

export default class ChangeIdFormInfo {
    constructor(changeIdFormInfo, $translate) {
        this.translate = $translate;
        this.corporateName = changeIdFormInfo.corporateName;
        this.countryCode = changeIdFormInfo.countryCode;
        this.creationDate = changeIdFormInfo.creationDate;
        this.email = changeIdFormInfo.email;
        this.firstname = changeIdFormInfo.firstname;
        this.idFiscalKind = changeIdFormInfo.idFiscalKind;
        this.idFiscal = changeIdFormInfo.idFiscal;
        this.idNational = changeIdFormInfo.idNational;
        this.idNationalKind = changeIdFormInfo.idNationalKind;
        this.idNationalKindLabel = changeIdFormInfo.idNationalKindLabel;
        this.lastname = changeIdFormInfo.lastname;
        this.message = changeIdFormInfo.message;
        this.phone = changeIdFormInfo.phone;
        this.job = changeIdFormInfo.job;
    }

    getCountryLabel() {
        var countryLabel = '';
        if (this.countryCode) {
            countryLabel =
                this.countryCode + ' - ' + this.translate.instant('country.' + angular.lowercase(this.countryCode));
        }
        return countryLabel;
    }

    getIdFiscalKind() {
        var idFiscalKind = this.translate.instant('kiss_seller.edit.inactive_form.not_liable_to_vat');
        if (this.idFiscal) {
            idFiscalKind = this.idFiscalKind;
        }
        return idFiscalKind;
    }
}
